import {
  withTranslation,
} from 'react-i18next';

import RegattaBoatRentsSectionView from './RegattaBoatRentsSectionView';

const TranslatedComponent = withTranslation()(RegattaBoatRentsSectionView);

const Component = TranslatedComponent;

export default Component;
